import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AssociateBrandService } from '@/services/AssociateBrand/AssociateBrandService';

export type AssociateBrand = {
  id: number;
  name: string;
};

export const useAssociateBrandList = async (): Promise<AssociateBrand[]> => {
  const brandService = new AssociateBrandService(getClient());
  try {
    return brandService.list();
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
